const getters = {
  getResults: (state) => {
    if (state.result != null) {
      return state.result.data;
    }
  },
  getFilter: (state) => state.filter,
  getPagination: (state) => state.pagination,
  getHasShowMore: (state) =>
    state.results.chunked.filter((item) => item.length > 0).length > 0,
};

export default getters;
